import { render, staticRenderFns } from "./CoachCardPlain.vue?vue&type=template&id=1e67dae6&"
import script from "./CoachCardPlain.vue?vue&type=script&lang=js&"
export * from "./CoachCardPlain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CoachCardPlain.vue"
export default component.exports